import React from 'react';
import { Card, Tag } from 'antd';
import dayjs from 'dayjs';


const ActiveMembershipCard = ({ subscription }) => {
  return (
    <Card title="Tu membresía" style={{ marginTop: 24 }}>
      <p>
        <strong>Plan:</strong> {subscription.name || subscription.planName || subscription.code || '-'}
      </p>

      <p>
        <strong>Vigencia:</strong>{' '}
        {dayjs(subscription.startDate).format('DD/MM/YYYY')} -{' '}
        {dayjs(subscription.endDate).format('DD/MM/YYYY')}
      </p>

      <Tag color="green">{subscription.status}</Tag>
    </Card>
  );
};

export default ActiveMembershipCard;
